module.exports = __webpack_public_path__ + "static/media/HCMM809.4a8e62c5.jpg";